import React from 'react';
import { WiDaySunny, WiMoonAltWaxingGibbous3, WiStrongWind } from 'react-icons/wi';
import { GiDeerTrack } from 'react-icons/gi';

const TRACK_STEPS = [
  { id: 'moon', label: 'Checking the moon phase…', Icon: WiMoonAltWaxingGibbous3 },
  { id: 'weather', label: 'Pulling weather data…', Icon: WiDaySunny },
  { id: 'wind', label: 'Sifting through the wind reports…', Icon: WiStrongWind },
  { id: 'lineup', label: 'Looking for the best spots…', Icon: GiDeerTrack },
];

export default function ForecastTrackLoader({ message }) {
  return (
    <div className="hf-track-loader" role="status" aria-live="polite" data-testid="hf-forecast-loader">
      <div className="hf-track-loader__title">{message || "Scouting today's best sits…"}</div>
      <div className="hf-track-loader__line">
        {TRACK_STEPS.map((step, idx) => {
          const Icon = step.Icon || GiDeerTrack;
          return (
            <div
              className="hf-track-loader__step"
              key={step.id}
              style={{ animationDelay: `${idx * 0.9}s` }}
            >
              <Icon className="hf-track-loader__icon" size={32} aria-hidden="true" />
              <div className="hf-track-loader__label">{step.label}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
